document.addEventListener("DOMContentLoaded", function () {
  const isBespokePlanField = document.getElementById("isBespokePlan");
  if (!isBespokePlanField || isBespokePlanField.value !== "true") return;

  const buyButtons = document.querySelector('.buy-buttons-block');
  const price = document.querySelector('product-price');
  const productForm = document.querySelector('.product-form__buttons');
  const formApp = document.querySelector('.pxFormGenerator'); 
  const qtyInput = document.querySelector('.quantity-input');

  function toggleBespokeVisibility(isBespoke, form) {
    if (isBespoke) {
      form.classList.add('bespoke-is-active');
      if (formApp) formApp.style.setProperty('display', 'block', 'important');
      if (buyButtons) buyButtons.style.display = "none";
      if (price) price.style.display = "none";
      if (productForm) productForm.style.display = "none";
      if (qtyInput) qtyInput.style.display = "none";
    } else {
      form.classList.remove('bespoke-is-active');
      if (formApp) formApp.style.setProperty('display', 'none', 'important');
      if (buyButtons) buyButtons.style.display = "block";
      if (price) price.style.display = "block";
      if (productForm) productButtons.style.display = "block";
      if (qtyInput) qtyInput.style.display = "flex";
    }
  }

  const bespokeObserver = new MutationObserver((mutations) => {
    const fieldset = document.querySelector("fieldset.variant-option--buttons");
    const parentForm = fieldset ? fieldset.closest('form') : null;
    
    if (fieldset && parentForm && !parentForm.querySelector(".bp-option")) {
      // 1. Create the Button as a DIV (Theme JS will ignore this)
      const bespokeBtn = document.createElement("div");
      bespokeBtn.className = "variant-option__button-label bp-option";
      bespokeBtn.innerHTML = `<span>Bespoke Plan</span>`;

      // 2. Insert it AFTER the fieldset but INSIDE the form
      parentForm.classList.add('custom-variant-row');
      fieldset.parentNode.insertBefore(bespokeBtn, fieldset.nextSibling);

      // 3. Handle Clicking Bespoke
      bespokeBtn.addEventListener("click", function () {
        this.setAttribute('data-bespoke-active', 'true');
        toggleBespokeVisibility(true, parentForm);
      });

      // 4. Handle Clicking Real Variants (Deactivates Bespoke)
      fieldset.addEventListener("change", function(e) {
        if (e.target.type === 'radio') {
          bespokeBtn.removeAttribute('data-bespoke-active');
          toggleBespokeVisibility(false, parentForm);
        }
      });
    }
  });

  bespokeObserver.observe(document.body, { childList: true, subtree: true });
});